import { PublicCallback } from 'globals/types';
import { importAndInitializePubNub } from 'core_main/globals/vendors';
import { getStore } from 'core_main/store';
import { createSession } from 'core_main/api/sessions';
import { ON_CONVERSATION_CREATE_EVENT_TYPE } from 'core/constants';
import { runListenersForEvent } from 'core_main/globals/events';
import {
  createConversationCallbackResponse,
  createNewConversationStatusEventListener,
} from './helpers';
import { CreateConversationParameters } from './types';
import { ConversationCallbackResponse } from '../types';

export const createConversation = (
  parameters: CreateConversationParameters,
  cb?: PublicCallback,
) => {
  return createSession(parameters)
    .then((response) => {
      const customerId = response.data.relationships.customer.data.id;
      const { orgId } = getStore();
      return importAndInitializePubNub({
        customerId,
        orgId,
      }).then((pubnub) => ({ pubnub, response }));
    })
    .then(({ pubnub, response }) => {
      const { channels } = response?.data?.attributes.pubnub.data || {};
      const sharedConversationChannel = channels.find(
        (channel) => channel.type === 'shared-conversation',
      );

      const sharedConversationChannelName = sharedConversationChannel?.name;

      const conversationChannels = sharedConversationChannelName
        ? [sharedConversationChannelName]
        : undefined;
      if (conversationChannels) {
        const listenerParams = {
          status: createNewConversationStatusEventListener(
            {
              pubnub,
              conversationChannels,
            },
            (_, error) => {
              let callbackResponse: ConversationCallbackResponse | null = null;
              if (error) {
                // remove the subscription for channels where subscribe failed (otherwise pubnub will try to subscribe to it on the next call to subscribe)
                pubnub.getMetaPubNub()?.instance?.unsubscribe({
                  channels: conversationChannels,
                });
              } else {
                callbackResponse = createConversationCallbackResponse(response);
              }
              pubnub?.getMetaPubNub()?.instance?.removeListener(listenerParams);
              runListenersForEvent(
                ON_CONVERSATION_CREATE_EVENT_TYPE,
                callbackResponse,
                error,
              );

              if (typeof cb === 'function') {
                cb(callbackResponse, error);
              }
            },
          ),
        };
        pubnub.getMetaPubNub()?.instance?.addListener(listenerParams);
      }
      pubnub.getMetaPubNub()?.instance?.subscribe({
        channels: conversationChannels,
      });
      return pubnub;
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      runListenersForEvent(ON_CONVERSATION_CREATE_EVENT_TYPE, null, error);
      console.error('Failed to create conversation:', error);
    });
};
